/**
 * @module experience/refill-account
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// TODO: Evaluate if constants are required
export const REFILL_ACCOUNT_CONSTANTS = {
  AUTO_PAY_MESSAGE_ON: 'ON',
  AUTO_PAY_MESSAGE_OFF: 'OFF',
  NOTPAID: 'notpaid',
  ACCOUNT_STATUS_ACTIVE: 'ACTIVE',
  ACCOUNT_STATUS_SUSPENDED: 'SUSPENDED',
  ACCOUNT_STATUS_PAID: 'Paid',
  ACCOUNT_STATUS_UNPAID: 'Unpaid',
  ACCOUNT_STATUS_NOTAPPLICABLE: 'N/A',
  REFILL_ACCOUNT_MODULE: 'RefillAccountModule',
  REDEEM_CARD_FUND_DETAILS_COMPONENT: 'RedeemCardFundDetailsComponent',
  REDEEM_CARD_BILLING_DETAILS_COMPONENT: 'RedeemCardBillingDetailsComponent',
  CONTAINER_HOLDER: 'container-holder',
  HEADINGCOLCONTROL_ID: 'headingColControl',
  COLUMNCONTROL_ID: 'columnControl',
  LEGAL_TEXT: 'legal-text',
  REFILL_OVERFUNDING: 'REFILL-OVERFUNDING',
  NOT_AllOWED: 'Not-Allowed',
  FALSE: 'false',
  ONE: '1',
  REDEEM_REFILL: 'redeemRefill',
};
